import { Typography } from 'antd';
import { LegalDocumentLayout } from 'components/LegalDocumentLayout';
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export const TermsOfUse: React.FC = () => {
  const { t } = useTranslation();
  const { Text, Title } = Typography;
  const textStyle = { fontSize: '14px', fontWeight: '300' };
  return (
    <React.Fragment>
      <Helmet>
        <title>{`${t('legal.terms-title')} | ${process.env.PROJECT_NAME}`}</title>
        <meta name="description" content={t('legal.terms-meta-description')} />
      </Helmet>
      <LegalDocumentLayout>
          <Title level={4}>{t('legal.terms-title')}</Title>
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.service-title')}
          </Text>
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '18px', fontWeight: '300' }}>
            {t('legal.website-url')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.terms-content.introduction-p1')}
            <br />
            <br />
            {t('legal.terms-content.introduction-p2')}
            <br />
            <br />
            {t('legal.terms-content.introduction-p3')}
            <br />
            <br />
            {t('legal.terms-content.introduction-p4')}
            <br />
            <br />
            {t('legal.terms-content.introduction-p5')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.terms-sections.definitions')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            <i>{t('legal.terms-definitions.account-owner-label')}</i> - {t('legal.terms-definitions.account-owner-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.agreement-terms-label')}</i> - {t('legal.terms-definitions.agreement-terms-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.access-fee-label')}</i> - {t('legal.terms-definitions.access-fee-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.confidential-information-label')}</i> - {t('legal.terms-definitions.confidential-information-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.data-label')}</i> - {t('legal.terms-definitions.data-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.generate-tax-label')}</i> {t('legal.terms-definitions.generate-tax-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.intellectual-property-right-label')}</i> - {t('legal.terms-definitions.intellectual-property-right-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.service-label')}</i> - {t('legal.terms-definitions.service-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.saas-label')}</i> - {t('legal.terms-definitions.saas-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.third-party-applications-label')}</i> - {t('legal.terms-definitions.third-party-applications-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.website-label')}</i> - {t('legal.terms-definitions.website-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.user-label')}</i> - {t('legal.terms-definitions.user-body')}
            <br />
            <br />
            <i>{t('legal.terms-definitions.you-label')}</i> - {t('legal.terms-definitions.you-body')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.terms-sections.use-of-software')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.terms-content.use-of-software-intro')}
            <ul style={{ listStyleType: 'disc', margin: '15px' }}>
              <li>{t('legal.terms-use-of-software-list.account-owner-determines-user')}</li>
              <li>{t('legal.terms-use-of-software-list.account-owner-responsible-for-users')}</li>
              <li>{t('legal.terms-use-of-software-list.account-owner-controls-access')}</li>
              <li>{t('legal.terms-use-of-software-list.dispute-access-decided-by-owner')}</li>
            </ul>
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.terms-sections.your-obligations')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            <strong>{t('legal.terms-subsections.payment-obligations')}</strong> - {t('legal.terms-content.payment-obligations-p1')}
            <br />
            <br />
            {t('legal.terms-content.payment-obligations-p2')}
            <br />
            <br />
            {t('legal.terms-content.payment-obligations-p3')}
            <br />
            <br />
            {t('legal.terms-content.payment-obligations-p4')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.general-obligations')}</strong> - {t('legal.terms-content.general-obligations-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.access-conditions')}</strong> - {t('legal.terms-content.access-conditions-intro')}
            <br />
            <br />
            {t('legal.terms-content.access-conditions-list-intro')}
            <br />
            <ul style={{ listStyleType: 'disc', margin: '15px' }}>
              <li>{t('legal.terms-content.access-conditions-list.item-1')}</li>
              <li>{t('legal.terms-content.access-conditions-list.item-2')}</li>
              <li>{t('legal.terms-content.access-conditions-list.item-3')}</li>
              <li>{t('legal.terms-content.access-conditions-list.item-4')}</li>
              <li>{t('legal.terms-content.access-conditions-list.item-5')}</li>
            </ul>
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.usage-limitations')}</strong> - {t('legal.terms-content.usage-limitations-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.communication-conditions')}</strong> - {t('legal.terms-content.communication-conditions-p1')}
            <br />
            <br />
            <br />
            {t('legal.terms-content.communication-conditions-p2')}
            <br />
            <br />
            {t('legal.terms-content.communication-conditions-p3')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.terms-sections.confidentiality-and-privacy')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            <strong>{t('legal.terms-subsections.confidentiality')}</strong> - {t('legal.terms-content.confidentiality-intro')}
            <br />
            <br />
            {t('legal.terms-content.confidentiality-p1')}
            <br />
            <br />
            {t('legal.terms-content.confidentiality-p2')}
            <br />
            <br />
            {t('legal.terms-content.confidentiality-list-intro')}
            <br />
            <ul style={{ listStyleType: 'disc', margin: '15px' }}>
              <li>{t('legal.terms-content.confidentiality-list.item-1')}</li>
              <li>{t('legal.terms-content.confidentiality-list.item-2')}</li>
              <li>{t('legal.terms-content.confidentiality-list.item-3')}</li>
              <li>{t('legal.terms-content.confidentiality-list.item-4')}</li>
            </ul>
            <br />
            <br />
            <strong>{t('legal.terms-subsections.privacy')}</strong> - {t('legal.terms-content.privacy-body')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.terms-sections.intellectual-property')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            <strong>{t('vat-forms.general')}</strong> - {t('legal.terms-content.intellectual-property-general-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.ownership-of-data')}</strong> - {t('legal.terms-content.intellectual-property-ownership-of-data-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.backup-of-data')}</strong> - {t('legal.terms-content.intellectual-property-backup-of-data-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.third-party-applications-and-data')}</strong> - {t('legal.terms-content.intellectual-property-third-party-applications-and-data-body')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.terms-sections.warranties-and-acknowledgements')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            <strong>{t('legal.terms-subsections.authority')}</strong> - {t('legal.terms-content.authority-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.acknowledgement')}</strong> - {t('legal.terms-content.acknowledgement-intro')}
            <br />
            <ol style={{ marginLeft: '15px' }}>
              <li>{t('legal.terms-content.acknowledgement-list.item-1')}</li>
              <li>
                {t('legal.terms-content.acknowledgement-list.item-2-intro')}
                <ol style={{ marginLeft: '15px' }}>
                  <li>{t('legal.terms-content.acknowledgement-list.item-2-nested.item-1')}</li>
                  <li>{t('legal.terms-content.acknowledgement-list.item-2-nested.item-2')}</li>
                </ol>
              </li>
              <li>
                {t('legal.terms-content.acknowledgement-list.item-3-intro')}
                <ol style={{ marginLeft: '15px' }}>
                  <li>{t('legal.terms-content.acknowledgement-list.item-3-nested.item-1')}</li>
                  <li>{t('legal.terms-content.acknowledgement-list.item-3-nested.item-2')}</li>
                </ol>
              </li>
              <li>{t('legal.terms-content.acknowledgement-list.item-4')}</li>
              <li>{t('legal.terms-content.acknowledgement-list.item-5')}</li>
              <li>{t('legal.terms-content.acknowledgement-list.item-6')}</li>
              <li>{t('legal.terms-content.acknowledgement-list.item-7')}</li>
              <li>{t('legal.terms-content.acknowledgement-list.item-8')}</li>
            </ol>
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.no-warranties')}</strong> - {t('legal.terms-content.no-warranties-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.consumer-guarantees')}</strong> - {t('legal.terms-content.consumer-guarantees-body')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.terms-sections.limitation-of-liability')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.terms-content.limitation-of-liability-p1')}
            <br />
            <br />
            {t('legal.terms-content.limitation-of-liability-p2')}
            <br />
            <br />
            {t('legal.terms-content.limitation-of-liability-p3')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.terms-sections.termination')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            <strong>{t('legal.terms-subsections.trial-policy')}</strong> - {t('legal.terms-content.trial-policy-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.prepaid-subscriptions-and-services')}</strong> - {t('legal.terms-content.prepaid-subscriptions-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.no-fault-termination')}</strong> - {t('legal.terms-content.no-fault-termination-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.breach')}</strong> - {t('legal.terms-content.breach-intro')}
            <br />
            <ol style={{ marginLeft: '15px' }}>
              <li>{t('legal.terms-content.termination-breach-list.item-1')}</li>
              <li>{t('legal.terms-content.termination-breach-list.item-2')}</li>
              <li>{t('legal.terms-content.termination-breach-list.item-3')}</li>
            </ol>
            <br />
            <br />
            {t('legal.terms-content.termination-actions-intro')}
            <br />
            <ol style={{ marginLeft: '15px' }}>
              <li>{t('legal.terms-content.termination-actions-list.item-1')}</li>
              <li>{t('legal.terms-content.termination-actions-list.item-2')}</li>
              <li>{t('legal.terms-termination-list.suspend-or-terminate-data-access')}</li>
              <li>{t('legal.terms-content.termination-actions-list.item-4')}</li>
            </ol>
            <br />
            <br />
            {t('legal.terms-content.termination-payment-clarification')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.accrued-rights-survival')}</strong> - {t('legal.terms-content.accrued-rights-survival-body')}
            <br />
            <ol style={{ marginLeft: '15px' }}>
              <li>{t('legal.terms-content.termination-accrued-rights-list.item-1')}</li>
              <li>{t('legal.terms-termination-list.immediately-cease-use')}</li>
            </ol>
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>{t('legal.terms-sections.help-desk')}</Text>
          <br />
          <br />
          <Text style={textStyle}>
            <strong>{t('legal.terms-subsections.technical-problems')}</strong> - {t('legal.terms-content.technical-problems-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.service-availability')}</strong> - {t('legal.terms-content.service-availability-body')}
            <br />
            <br />
            {t('legal.terms-content.service-availability-follow-up')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>{t('legal.terms-sections.general')}</Text>
          <br />
          <br />
          <Text style={textStyle}>
            <strong>{t('legal.terms-subsections.entire-agreement')}</strong> - {t('legal.terms-content.entire-agreement-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.waiver')}</strong> - {t('legal.terms-content.waiver-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.delays')}</strong> - {t('legal.terms-content.delays-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.no-assignment')}</strong> - {t('legal.terms-content.no-assignment-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.governing-law-and-dispute-resolution')}</strong> - {t('legal.terms-content.governing-law-and-dispute-resolution-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.severability')}</strong> - {t('legal.terms-content.severability-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.notices')}</strong> - {t('legal.terms-content.notices-body')}
            <br />
            <br />
            <br />
            <strong>{t('legal.terms-subsections.rights-of-third-parties')}</strong> - {t('legal.terms-content.rights-of-third-parties-body')}
            <br />
            <br />
            {t('legal.terms-content.general-closing')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <br />
          <Text style={textStyle}>
            <i>{t('legal.terms-last-updated')}</i>
          </Text>
          <br />
          <br />
      </LegalDocumentLayout>
    </React.Fragment>
  );
};
